export function selectSession() {
  return (state) => state.session.current;
}

export function selectUserError() {
  return (state) => state.user.error;
}

export function selectUser() {
  return (state) => state.user.current?.user ? state.user.current?.user : JSON.parse(localStorage.getItem('session_current'))?.user;
}

export function selectWorkspaces() {
  return (state) => state.user.current?.workspaces;
}

export function hasPermission(key) {
  return (state) => state.user.current?.user ? state.user.current?.user?.permissions?.includes(key) : JSON.parse(localStorage.getItem('session_current'))?.user?.permissions?.includes(key);
}

export function selectTwoFactorRequired() {
  return (state) => state.user.twoFactor?.required || false;
}

export function selectTwoFactorData() {
  return (state) => state.user.twoFactor;
}

export function selectNewPasswordRequired() {
  return (state) => state.user.newPasswordChallenge?.required || false;
}

export function selectNewPasswordChallenge() {
  return (state) => state.user.newPasswordChallenge;
}

export function selectCognitoTotpRequired() {
  return (state) => state.user.cognitoTotpChallenge?.required || false;
}

export function selectCognitoTotpChallenge() {
  return (state) => state.user.cognitoTotpChallenge;
}